import { HttpClient } from '@angular/common/http';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  collection,
  Firestore,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
  collectionSnapshots,
} from '@angular/fire/firestore';
import { from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class InstanceService {
  constructor(private http: HttpClient) {}

  private firestore = inject(Firestore);
  private destroyRef = inject(DestroyRef);

  createInstance(instance: object) {
    const instanceRef = collection(this.firestore, 'instances');
    return from(
      addDoc(instanceRef, instance)
        .then(() => 'success')
        .catch((err) => err)
    );
  }

  pingServer(path: string) {
    return this.http
      .post(`${path}/mimirPing`, { resp: 'idle' })
      .pipe(catchError((val) => of(val)));
  }

  getInstances() {
    return collectionSnapshots(collection(this.firestore, 'instances')).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((instances) =>
        instances.map((instance) => {
          const data = instance.data();
          const id = instance.id;
          return { id, ...data };
        })
      )
    );
  }

  updateInstance(id: string, update: any) {
    const instanceRef = doc(this.firestore, `instances/${id}`);
    updateDoc(instanceRef, update);
  }

  removeInstance(id: string) {
    const instanceRef = doc(this.firestore, `instances/${id}`);
    deleteDoc(instanceRef);
  }
}
